"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calusco-d-adda": {
    "b6bed304": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "baccanello": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fc1e6f7": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "calusco-centro": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "026a41a7": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "capora": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "326d4648": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "luprita": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "adbbfa4b": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "montello": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f240991c": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "565d22c7": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "skipSearch": false
    }],
    "vanzone": [{
      "hkey": "fd8ee854",
      "slug": "calusco-d-adda",
      "name": "Calusco d'Adda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;